import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { SET_CURRENT_PROFILE } from '../../http/apollo-queries';

import { useAuth } from '../../context/Auth';
import { Icon, Loading } from '../../components/UI';
import { Modal } from '../../components/Modal';
import { logger } from '../../helpers/logger';

const ChooseAccount = () => {
  const { user, refetch } = useAuth();
  const [setCurrentProfile, { loading }] = useMutation(SET_CURRENT_PROFILE, {
    onCompleted: (data) => {
      refetch().then(() => {
        // navigate('/actual'); 07-06-'22
        navigate('/strategies');
      });
    },
    onError: (err) => {
      logger.error(err);
      toast.error(t('chooseAccount.error'));
    },
  });
  const [selectedProfile, setSelectedProfile] = useState(user?.profile?.id);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'huge'}
    >
      <div className={'text-center h-full flex flex-col'}>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          {t('chooseAccount.title')}
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          {t('chooseAccount.subtitle')}
        </p>
        <div className="mt-8 overflow-y-auto scrollbar-hide">
          {user &&
            user.profiles.items.map((profile: any, index: number) => {
              return (
                <div
                  key={profile.id}
                  onClick={() => {
                    setSelectedProfile(profile.id);
                    setCurrentProfile({
                      variables: {
                        profileId: profile.id,
                      },
                    });
                  }}
                  className={`w-80 mb-4 w-12 mx-auto flex cursor-pointer duration-300 items-center transition-colors hover:bg-lime rounded-3xl
                  ${
                    selectedProfile === profile.id ? 'bg-primary' : 'bg-grey-10'
                  }
                    ${loading ? 'pointer-events-none' : ''}
                `}
                >
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-primary flex justify-center items-center">
                    <img
                      alt={'profile-avatar'}
                      src={profile.avatar?.size?.avatarLarge}
                    />
                  </div>
                  <span className="ml-4 text-black font-semibold">
                    {profile.name}
                  </span>
                  <Loading
                    className="ml-4"
                    status={loading && selectedProfile === profile.id}
                    size="small"
                  />
                  <Icon
                    className="ml-auto mr-1 w-8"
                    color="black"
                    svgName={'chevronRight'}
                  />
                </div>
              );
            })}
          <div
            className="w-80 w-12 mt-4 mx-auto flex cursor-pointer duration-300 items-center transition-colors rounded-3xl hover:bg-lime bg-grey-10"
            onClick={() => navigate('/choose-username?newAccount=true')}
          >
            <div className="w-12 h-12 rounded-full bg-primary flex justify-center items-center">
              <Icon className="mx-auto w-8" color="black" svgName={'plus'} />
            </div>
            <span className="ml-4 text-black font-semibold">
              Create new account
            </span>
            <Icon
              className="ml-auto mr-1 w-8"
              color="black"
              svgName={'chevronRight'}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ChooseAccount;
